import React, { useEffect } from 'react';
import { Card, Descriptions, Image, Button, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchBDEs } from '../store/bdeSlice';
import { API_URL } from '../utils/api';

const ShopDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { shops, loading } = useSelector((state) => state.shops);
  const { users: bdes } = useSelector((state) => state.bde);
  const shop = shops.find((s) => s.id === id);

  useEffect(() => {
    dispatch(fetchBDEs());
  }, [dispatch]);

  if (loading && !shop) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!shop) {
    return (
      <Card>
        <div>Shop not found</div>
        <Button onClick={() => navigate('/admin/shops')}>Back to List</Button>
      </Card>
    );
  }

  const imageUrl = shop.boardImageUrl
    ? (shop.boardImageUrl.startsWith('http') ? shop.boardImageUrl : `${API_URL}${shop.boardImageUrl}`)
    : null;

  const bdeName = shop.bdeId ? (bdes.find(u => u.id === shop.bdeId)?.name || shop.bdeId) : null;

  return (
    <Card
      title="Shop Details"
      extra={<Button onClick={() => navigate('/admin/shops')}>Back</Button>}
    >
      <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        {imageUrl && (
          <div style={{ flexShrink: 0 }}>
            <Image
              width={300}
              src={imageUrl}
              alt={shop.name}
              style={{ borderRadius: '8px', objectFit: 'cover' }}
            />
          </div>
        )}
        <div style={{ flexGrow: 1, minWidth: '300px' }}>
          <Descriptions bordered column={1} labelStyle={{ width: '150px', fontWeight: 'bold' }}>
            <Descriptions.Item label="Shop Name">{shop.name}</Descriptions.Item>
            <Descriptions.Item label="Added By">{bdeName ? `${bdeName} (BDE)` : 'Admin'}</Descriptions.Item>
            <Descriptions.Item label="Owner Name">{shop.ownerName}</Descriptions.Item>
            <Descriptions.Item label="Owner Number">{shop.ownerNumber}</Descriptions.Item>
            <Descriptions.Item label="Contact Number">{shop.contactNumber}</Descriptions.Item>
            <Descriptions.Item label="Shop Type">{shop.shopType || 'General Store'}</Descriptions.Item>
            <Descriptions.Item label="Pincode">{shop.pincode}</Descriptions.Item>
            <Descriptions.Item label="GST No.">{shop.gstNo || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Address">{shop.address}</Descriptions.Item>
            <Descriptions.Item label="Location">{shop.location || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Created At">{new Date(shop.createdAt).toLocaleString()}</Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    </Card>
  );
};

export default ShopDetails;
